module.exports = __webpack_public_path__ + "static/payments-infrastructure-a5155037eab07e725ff1dde0bd9c6e17.gif";